import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import "./styles.scss";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { paymentRouteMap } from "../../store/reducer/payment";
import { RootState } from "../../store/index";
import CustomStepper from "../../components/CustomStepper";
import { Outlet, useOutletContext } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../components/ErrorFallback";
import { goBack } from "redux-first-history";
import { TaxCalculations } from "../../model/tax_calculations";
import { paymentSlice } from "../../store/reducer/payment";

type ContextType = { taxCalculations: TaxCalculations };

const steps = ["Payment Information", "Complete"];
const PaymentContainer: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const urlPath = location.pathname;
  const activeStep = paymentRouteMap[urlPath];
  const { taxCalculationsFetched, finalBalance } = useSelector((store: RootState) => store.payment);

  useEffect(() => {
    if (!taxCalculationsFetched) {
      dispatch(paymentSlice.actions.finalBalanceRequest());
    }
  }, []);

  useEffect(() => { 
    document.title = import.meta.env.VITE_APP_NAME + ' - Payment - ' + steps[activeStep];
  }, [location]);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Layout>
        <CustomStepper
          steps={steps}
          activeStep={activeStep}
          handleBack={() => dispatch(goBack())}
          showBackButton={false}
          hideNextButton={true}
          className="payment-stepper"
        >
          <Outlet context={{ taxCalculations: finalBalance }} />
        </CustomStepper>
      </Layout>
    </ErrorBoundary>
  );
};

export default PaymentContainer;

export function usePaymentContainerContext() {
  return useOutletContext<ContextType>();
}
